import { gql } from "@apollo/client";

export const GENERATE_INVOICE_PDF = gql`
  mutation generateInvoicePdf($invoiceId: ID!) {
    generateInvoicePdf(invoiceId: $invoiceId){
        invoiceUrl
    }
  }
`;